/**
 * This code was generated by Builder.io.
 */
import React, { useState } from "react";
import styles from "./PremiumSelection.module.css";
import { PremiumOption } from "./types";

const PremiumListSection: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");

  const premiumOptions: PremiumOption[] = [
    { label: "Premium Report" },
    { label: "Premium Adjustment" },
    { label: "Single Premium Certificate Return" },
  ];

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };

  return (
    <section className={styles.premiumListSection}>
      <h2 className={styles.premiumListTitle}>Premium List</h2>
      {premiumOptions.map((option, index) => (
        <div key={index} className={styles.premiumOption}>
          <input
            type="radio"
            name="premiumOption"
            className={styles.optionRadio}
            id={`option-${index}`}
            value={option.label}
            checked={selectedOption === option.label}
            onChange={handleOptionChange}
          />
          <label htmlFor={`option-${index}`} className={styles.optionLabel}>
            {option.label}
          </label>
        </div>
      ))}
    </section>
  );
};

export default PremiumListSection;
